import React, {useState,useEffect} from 'react'
import Oatnavbar from '../Components/Oatnavbar';
import Oatsidebar from '../Components/Oatsidebar';
import OatEntityMain from '../Components/OatEntityMain'
import {Link} from 'react-router-dom'

const OatEntity = () => {
  const [sidebar , setSidebarOpen]=useState(false);

  const togglesidebar =()=> {
    setSidebarOpen((prevState) => !prevState);
  }
   const toggleLogout =()=>{

    document.getElementById("modalLogoutForm").style.display = "block";
   }

  function removelocalstorage(){
      

     

    localStorage.clear();
    window.location.href='/'


}

 function closeForm()
 {
    document.getElementById("modalLogoutForm").style.display = "none";
  
  }

  useEffect(()=>{
      
    const venture = localStorage.getItem('ventureid');

    let OATcheck = venture.includes('03')
   


if(OATcheck==true){
  document.getElementById("Oat-dashboard").style.display="grid"
}
else{
  document.getElementById("Oat-dashboard").style.display="none"
}

  
 },[]);
 return (
  <div className='oat-container' id="Oat-dashboard">
  <Oatnavbar sidebar={sidebar} openSidebar={togglesidebar}/>
  
  <Oatsidebar sidebar={sidebar} openLogForm={toggleLogout}/>

 
  
  <OatEntityMain />

  <div className="oat-pop-fade" id="modalLogoutForm" tabindex="-1" role="dialog">
   <div className="modal-dialog" role="document">
    <div className="modal-content" style={{marginTop:"240px"}}>
    <div className="modal-header text-center">
      <h4 className="modal-title w-100 font-weight-bold">LOG OUT</h4>
      <button type="button" className="close" onClick={closeForm}>
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

  <form id='form'>

   <div className="modal-body mx-3">

      <div className="md-form mb-4">
          <div className='text-center'>
        <h5 style={{marginTop:"25px"}}>Are you sure want to logout?</h5>
        </div>
      </div>

    </div>

     <div className="modal-footer d-flex justify-content-center">
      <Link to="/"><button className="oat-adduser-button" onClick={removelocalstorage} type='submit'>Confirm</button></Link>
      <button className="oat-adduser-button" onClick={closeForm} type='submit'>Cancel</button>
     </div>

     </form>
    
   </div>
  </div>
</div>
  </div>
)
}


export default OatEntity
